// src/components/VerifiedRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const VerifiedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  // If no user exists or user is not verified, redirect to the root ("/")
  if (!user || !user.emailVerified) {
    // Prevent redirect loop if already at "/"
    if (location.pathname !== "/") {
      return <Navigate to="/" replace />;
    }
    return null; // Or show a placeholder message if you want
  }

  // If user is authenticated and verified
  return children;
};

export default VerifiedRoute;